import {addMonths} from 'date-fns';

import {SetValueConfig, UseFormReturn} from 'react-hook-form';

import {getApiDateString, parseDate} from 'shared/web';

import {BaseVehicle} from '../../types/BaseVehicle';
import {FluidReplacementServiceIntervals} from '../../types/RentalVehicle';

export interface FormCalculateFluidNextReplacementDateFromMonthsActionParams {
  form: UseFormReturn<BaseVehicle>;
  name: FluidReplacementServiceIntervals;
  value: number | null;
}

const DEFAULT_OPTIONS = {
  shouldDirty: true,
  shouldValidate: true,
} satisfies SetValueConfig;

/**
 * XState action for calculating the next fluid replacement date when the months interval changes.
 * Uses the last replacement date and the new months interval to calculate the next replacement date.
 *
 * @param _context - XState context (unused)
 * @param params - Parameters containing form instance, fluid name and months interval value
 */
export const formCalculateFluidNextReplacementDateFromMonthsAction = (
  _context: unknown,
  params: FormCalculateFluidNextReplacementDateFromMonthsActionParams
): void => {
  const {form, name, value} = params;

  const lastReplacementDate = form.getValues(`serviceIntervals.${name}.lastReplacementDate`);
  const lastReplacementMonths = value;

  if (!lastReplacementDate || !lastReplacementMonths) {
    return;
  }

  const parsedLastDate = parseDate(lastReplacementDate);
  if (!parsedLastDate) {
    return;
  }

  const nextDate = addMonths(parsedLastDate, lastReplacementMonths);

  form.setValue(
    `serviceIntervals.${name}.nextReplacementDate`,
    getApiDateString(nextDate),
    DEFAULT_OPTIONS
  );
};
